import axios from "axios"
import { endpointApi } from "../../utils";
import { EMPLOYEE_LIST_FAIL, EMPLOYEE_LIST_REQUEST, EMPLOYEE_LIST_SUCCESS } from "../constats/employee.constant";
import { logout } from "./auth.action";

export const getEmployees = (location=null, navigate=null) => async (dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: EMPLOYEE_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }employees${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: EMPLOYEE_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: EMPLOYEE_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: EMPLOYEE_LIST_FAIL,
                payload: err.response && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}